import { Box } from '@mui/material';
import React from 'react';

import { CTA } from '../_components/CTA.tsx';
import { RulesCard } from '../_components/RulesCard.tsx';
import { Section } from '../_components/Section.tsx';

export type RulesSectionProps = {
  // Empty
};

export const RulesSection: React.FC<RulesSectionProps> = () => {
  return (
    <Section
      sx={{
        gap: { xs: '60px', lg: '100px' },
        flexDirection: { md: 'row' },
        alignItems: { md: 'center' },
      }}
    >
      <Box
        sx={{
          flex: 1,
        }}
      >
        <Box
          sx={{
            display: 'grid',
            maxWidth: { md: '480px' },
            marginLeft: { md: 'auto' },
            marginTop: { lg: 4 },
          }}
        >
          <div className="mb-6 typography-v1-h1">
            Bruk{' '}
            <Box
              component="span"
              sx={{
                color: 'primary.main',
              }}
            >
              gjeldvett!
            </Box>
          </div>
          <div className="mb-6 typography-v1-body2 lg:mb-10">
            Vi mener at det er viktig å sjekke om du kan få lavere rente. Det kan nemlig spille en
            stor rolle i din økonomi.
          </div>
          <CTA sx={{ margin: { md: 0 } }} />
        </Box>
      </Box>
      <RulesCard sx={{ flex: 1 }} />
    </Section>
  );
};
